<template>
  <ul class="widget-multi-locations px-6 pb-2">
    <template
      v-for="location in practiceLocations"
    >
      <li
        v-if="location.callTrackingNumber"
        :key="location.locationId"
        class="widget-multi-locations__location pt-3 pb-1"
      >
        <p class="text-h5 mb-2">
          {{ location.name }}
        </p>
        <p
          v-if="location.address"
          class="text-h6 mb-0"
        >
          {{ location.address }}
        </p>
        <p
          v-if="location.address2"
          class="text-h6 mb-1"
        >
          {{ location.address2 }}
        </p>
        <pp-button
          class="pl-0 text-h5"
          type="plain"
          :text="location.callTrackingNumber"
          prepend-icon="phone"
          :href="'tel:' + location.callTrackingNumber"
          :target="isMobileSafari && '_blank'"
          @click="trackLocationCallUsClick(location)"
        />
      </li>
    </template>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MultiLocationCallUs',
  computed: {
    ...mapGetters({
      practiceLocations: 'practiceLocations',
      isMobileSafari: 'isMobileSafari'
    })
  },
  methods: {
    trackLocationCallUsClick (location) {
      this.$ppAnalytics.trackEvent({
        action: 'multi_channel_location_phone',
        label: location.callTrackingNumber
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.widget-multi-locations {
  max-height: 511px;
  overflow: auto;

  &__location {
    border-bottom: 1px solid $grey-40;
  }
}
</style>
